import { render, staticRenderFns } from "./CheckoutEndpointConfigurator.vue?vue&type=template&id=3c147e90&scoped=true"
import script from "./CheckoutEndpointConfigurator.vue?vue&type=script&lang=js"
export * from "./CheckoutEndpointConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c147e90",
  null
  
)

export default component.exports